export function GetRestrictionModes() {
  return [
    {
      key: 0,
      description: "Include"
    },
    {
      key: 1,
      description: "Exclude"
    }
  ];
}

export function GetRestrictionModeDescription(value) {
  let restrictionMode = GetRestrictionModes().find(item => item.key === value);
  return restrictionMode ? restrictionMode.description : "";
}
